/**
 * SecurityKey object.
 */
export abstract class SecurityKey {
	/**
	 * SecurityKey constructor.
	 */
	constructor() {}
}
